<template>
  <div class="forum-wrapper">
    <v-container fluid class="forum-dashboard-container">
      <v-row justify="center">
        <v-col cols="12" sm="8" md="6">
          <v-card outlined class="forum-card">
            <v-card-title class="text-h5">
              {{ isEdit ? "Edit Forum Category" : "Create Forum Category" }}
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  v-model="formData.name"
                  :rules="[rules.required]"
                  label="Category Name"
                  variant="outlined"
                  dense
                  required
                />
                <v-textarea
                  v-model="formData.description"
                  label="Description"
                  variant="outlined"
                  dense
                />
                <!-- No bar selection: backend will use get_active_bar -->
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="submitCategory">
                {{ isEdit ? "Save Changes" : "Save Category" }}
              </v-btn>
              <v-btn variant="text" @click="cancel">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ForumCategoryForm",
  data() {
    return {
      valid: false,
      formData: {
        name: "",
        description: "",
      },
      rules: {
        required: (v) => !!v || "Required",
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
  },
  methods: {
    async fetchCategory() {
      try {
        const res = await axios.get(
          `/api/forum-categories/${this.$route.params.id}/`,
          { withCredentials: true }
        );
        this.formData.name = res.data.name;
        this.formData.description = res.data.description || "";
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    },
    async submitCategory() {
      if (!this.$refs.form.validate()) {
        return;
      }
      try {
        if (this.isEdit) {
          await axios.put(
            `/api/forum-categories/${this.$route.params.id}/`,
            this.formData,
            { withCredentials: true }
          );
        } else {
          await axios.post("/api/forum-categories/", this.formData, {
            withCredentials: true,
          });
        }
        this.$router.push("/forum");
      } catch (error) {
        console.error("Error saving category:", error);
      }
    },
    cancel() {
      this.$router.push("/forum");
    },
  },
  created() {
    if (this.isEdit) {
      this.fetchCategory();
    }
  },
  mounted() {
    setTimeout(() => {
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }, 200);
  },
};
</script>

<style scoped>
.forum-wrapper {
  overflow: hidden;
}

.forum-dashboard-container {
  background: linear-gradient(to bottom, #fafafa, #e7effa, #d2e3f5);
  padding: 20px;
  min-height: 100vh;
  position: relative;
}

.forum-card {
  background-color: #fff;
  border-radius: 8px;
}
</style>